import { useEffect, useState } from 'react';

const EMAIL_CONFIRM_COOLDOWN_KEY = 'email_confirm_last_sent_at';
const COOLDOWN_DURATION = 60_000; // 1 минута в мс

export const useEmailCooldown = () => {
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    const lastSent = Number(localStorage.getItem(EMAIL_CONFIRM_COOLDOWN_KEY));
    const now = Date.now();

    if (lastSent && now - lastSent < COOLDOWN_DURATION) {
      setIsDisabled(true);
      const remaining = COOLDOWN_DURATION - (now - lastSent);
      const timer = setTimeout(() => setIsDisabled(false), remaining);
      return () => clearTimeout(timer);
    }
  }, []);

  const startCooldown = () => {
    localStorage.setItem(EMAIL_CONFIRM_COOLDOWN_KEY, Date.now().toString());
    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), COOLDOWN_DURATION);
  };

  const endCooldown = () => {
    localStorage.removeItem(EMAIL_CONFIRM_COOLDOWN_KEY);
    setIsDisabled(false);
  };

  return { isDisabled, startCooldown, endCooldown };
};
